const shipments = [
    {
        id: 1,
        orderId: "#TBT1",
        shipment_no: "TBSN15412120001",
        customer_name: "Daniel Gonzalez",
        supplier: "iTest Factory",
        location: "Germany",
        order_date: "23 Dec, 2022",
        arrival_date: "15 Jan, 2023",
        status: "Delivered"
    }, {
        id: 2,
        orderId: "#TBT2",
        shipment_no: "TBSN15412124512",
        customer_name: "Terry White",
        supplier: "Themesbrand",
        location: "Jersey",
        order_date: "06 Jan, 2023",
        arrival_date: "19 Jan, 2023",
        status: "Pending"
    }, {
        id: 3,
        orderId: "#TBT3",
        shipment_no: "TBSN15412102154",
        customer_name: "Heather Jimenez",
        supplier: "Scott Wilson",
        location: "Spain",
        order_date: "12 Oct, 2022",
        arrival_date: "01 Nov, 2022",
        status: "Delivered"
    }, {
        id: 4,
        orderId: "#TBT4",
        shipment_no: "TBSN15414512307",
        customer_name: "Phoenix Colon",
        supplier: "Scott Fry",
        location: "Albania",
        order_date: "03 Jan, 2023",
        arrival_date: "20 Jan, 2023",
        status: "Shipping"
    }, {
        id: 5,
        orderId: "#TBT5",
        shipment_no: "TBSN15414516748",
        customer_name: "Albie Guerra",
        supplier: "Farhan Stein",
        location: "Poland",
        order_date: "16 Jan, 2023",
        arrival_date: "29 Feb, 2023",
        status: "Pickups"
    }, {
        id: 6,
        orderId: "#TBT6",
        shipment_no: "TBSN15414521032",
        customer_name: "Devon Patton",
        supplier: "Zibra Cube",
        location: "UA",
        order_date: "02 Feb, 2023",
        arrival_date: "24 Mar, 2023",
        status: "Shipping"
    }, {
        id: 7,
        orderId: "#TBT7",
        shipment_no: "TBSN15414523654",
        customer_name: "Saoirse Blake",
        supplier: "Micro Design",
        location: "Sweden",
        order_date: "13 Sep, 2022",
        arrival_date: "07 Jan, 2023",
        status: "Pending"
    }, {
        id: 8,
        orderId: "#TBT8",
        shipment_no: "TBSN15414527498",
        customer_name: "Amanda Cortez",
        supplier: "Android Galaxy",
        location: "Serbia",
        order_date: "20 Mar, 2022",
        arrival_date: "09 May, 2022",
        status: "Pickups"
    }, {
        id: 9,
        orderId: "#TBT9",
        shipment_no: "TBSN15414524986",
        customer_name: "Lochlan Green",
        supplier: "Zibra Cube",
        location: "Ukraine",
        order_date: "12 Aug, 2022",
        arrival_date: "17 Sep, 2022",
        status: "Delivered"
    }, {
        id: 10,
        orderId: "#TBT10",
        shipment_no: "TBSN15414521452",
        customer_name: "Billy Conway",
        supplier: "iTest Factory",
        location: "Italy",
        order_date: "04 Oct, 2022",
        arrival_date: "30 Dec, 2022",
        status: "Out Of Delivery"
    }, {
        id: 11,
        orderId: "#TBT11",
        shipment_no: "TBSN15414516748",
        customer_name: "Bertie Taylor",
        supplier: "Farhan Stein",
        location: "Poland",
        order_date: "16 Jan, 2023",
        arrival_date: "29 Feb, 2023",
        status: "Pickups"
    }, {
        id: 12,
        orderId: "#TBT12",
        shipment_no: "TBSN15414521032",
        customer_name: "Elaine Merkley",
        supplier: "Zibra Cube",
        location: "UA",
        order_date: "02 Feb, 2023",
        arrival_date: "24 Mar, 2023",
        status: "Shipping"
    }
]

export { shipments }